import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ROUTES } from './teacher.routes';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

//Components
import { Teacher } from './components/main/teacher.component';

//Services
import { CustomTranslationLoader } from '../app/services/custom-translation-loader';
import { TeacherProductViewResolverService } from './services/teacher-product-view.resolver.service';
import { TeacherActivityViewResolverService } from './services/teacher-activity-view-resolver.service';
import { GroupSelection } from './components/group-selection/group-selection.component';

@NgModule({
  declarations: [
    GroupSelection,
    Teacher
  ],
  imports: [
    CommonModule,
    ROUTES,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslationLoader
      }
    }),
    FormsModule,
    SharedModule
  ],
  providers:[
    TeacherProductViewResolverService,
    TeacherActivityViewResolverService,
  ]
})
export class TeacherModule {
}
